import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import { Link } from 'react-router'
import Breadcrumb from 'component/Breadcrumb'

const Rupture = (props) => {
  const { translate } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('ruptures.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  return (
    <div className='ruptures-page'>
      {renderBreadcrumb()}

      <div className='margin-left-double margin-right-double'>
        <Row className='margin-bottom-double padding-bottom-double'>
          <div className='center'>
            <Col xs={12} sm={6} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <Link to='/rupture/previous-day'>
                  <div className='medium-icon margin-top'>
                    <i className='glyph glyph-clock' />
                  </div>
                  <h3 className='name color-text'>
                    {translate('mobile.previousDayRupture')}
                  </h3>
                </Link>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <Link to='/rupture/older'>
                  <div className='medium-icon margin-top'>
                    <i className='glyph glyph-calendar' />
                  </div>
                  <h3 className='name color-text'>
                    {translate('mobile.olderRupture')}
                  </h3>
                </Link>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </div>
  )
}

Rupture.propTypes = {
  translate: PropTypes.func.isRequired,
}

export default Rupture
